import { defineStore } from 'pinia'
import AuthService from '@/services/AuthService.js'
import apiClient from "../services/MyClient.js";


/* eslint-disable */

export const useAuthStore = defineStore('authStore', {

    state: () => ({

        registerFormData: {
            name: '', 
            email: '',
            password: '',
            password_confirmation: ''
        },

        token: '',
        userData: {},
        currentPlan: {},
        userCanceledAndIsOnGracePeriod: false,
        endsAt: '',

        doesPasswordMatch: false,

        loginFormData: {
            email: '',
            password: '',
        },

        authCode: '',
        isLoading: false,
        errorMessage: '',
        successMessage: '',

        accountUsageData: {},

        email: '', //used for forgot password reset

        resetPasswordData: {
            email: '',
            password: '',
            password_confirmation: '',
            token: ''
        },


        // paddlePlanProducts: [
        //     { id: 1, name: 'Starter Plan', desc: "Best for freelancers, makers & creators", price: 29, paddle_id: 64889 },
        //     { id: 2, name: 'Pro Plan', desc: "Perfect for small and medium sized businesses", price: 79, paddle_id: 64890 },
        //     { id: 3, name: 'Business Plan', desc: "Ideal for companies looking to scale performance", price: 199, paddle_id: 64891 }, 
        // ],

        paddlePlanProducts: [],

        vendor_id: 129746, 

        plansTabOptions: [
            { id: 1, name: 'Monthly', type: 'monthly' },
            { id: 2, name: 'Annual', type: 'annual' }, 
        ],

        currentPlanTabType: 'monthly',

        selectedPaddlePlanId: null,

        starterPlanFeatures: [
            {id: 1, desc: "Monthly submissions up to 1,000"},
            {id: 2, desc: "2 live projects"},
            {id: 3, desc: "Custom Branding - White label your quiz by replacing the Convertlyio logo with your own"},
            {id: 4, desc: "Access to all project types from single outcome, answer-based outcome & score assessment quizzes"},
            {id: 5, desc: "Embed in any website"},
            {id: 6, desc: "Hosted URL - Convertlyio’s auto-generated URLs are hosted on our own servers, allowing you to quickly promote your quiz"},
            {id: 7, desc: "Number of visits - unlimited"},
            {id: 8, desc: "Number of pages - unlimited"},
            {id: 9, desc: "Logic Jumps/Skip Logic - You can link specific answers to different pages of your quiz which guides the prospect to a separate path resulting in a different outcome"},
            {id: 10, desc: "Submission email notifications"},
            {id: 11, desc: "Integrations - Send Submission data to over 6,000+ apps via Zapier"},
        ],

        proPlanFeatures: [
            {id: 1, desc: "Monthly submissions up to 5,000"},
            {id: 2, desc: "10 live projects"},
            {id: 3, desc: "Custom Branding - White label your quiz by replacing the Convertlyio logo with your own"},
            {id: 4, desc: "Access to all project types from single outcome, answer-based outcome & score assessment quizzes"},
            {id: 5, desc: "Embed in any website"},
            {id: 6, desc: "Hosted URL - Convertlyio’s auto-generated URLs are hosted on our own servers, allowing you to quickly promote your quiz"},
            {id: 7, desc: "Number of visits - unlimited"},
            {id: 8, desc: "Number of pages - unlimited"},
            {id: 9, desc: "Logic Jumps/Skip Logic - You can link specific answers to different pages of your quiz which guides the prospect to a separate path resulting in a different outcome"},
            {id: 10, desc: "Submission email notifications"},
            {id: 11, desc: "Integrations - Send Submission data to over 6,000+ apps via Zapier"},
        ],

        businessPlanFeatures: [
            {id: 1, desc: "Monthly submissions up to 15,000"},
            {id: 2, desc: "20 live projects"},
            {id: 3, desc: "Custom Branding - White label your quiz by replacing the Convertlyio logo with your own"},
            {id: 4, desc: "Access to all project types from single outcome, answer-based outcome & score assessment quizzes"},
            {id: 5, desc: "Embed in any website"},
            {id: 6, desc: "Hosted URL - Convertlyio’s auto-generated URLs are hosted on our own servers, allowing you to quickly promote your quiz"},
            {id: 7, desc: "Number of visits - unlimited"},
            {id: 8, desc: "Number of pages - unlimited"},
            {id: 9, desc: "Logic Jumps/Skip Logic - You can link specific answers to different pages of your quiz which guides the prospect to a separate path resulting in a different outcome"},
            {id: 10, desc: "Submission email notifications"},
            {id: 11, desc: "Integrations - Send Submission data to over 6,000+ apps via Zapier"},
        ],





    }),

    // persist: true, 

    persist: {
        merge: 'merge',
        paths: ['token', 'vendor_id'],  //only persist the
    },


    actions: {

        registerAdmin(){

            this.errorMessage = ''
            this.isLoading = true

            if(this.registerFormData.password != this.registerFormData.password_confirmation){

                this.errorMessage = "Passwords doesn't match"

                this.isLoading = false

                console.log("Passwords don't match")

            }else{



                apiClient.get('/sanctum/csrf-cookie').then(() => {

                    AuthService.registerUser(this.registerFormData)
                        .then((response) => { 
        
                            this.router.push({ name: 'LoginView' })
                            // this.router.push({ name: 'VerifyAuthCode' })
    
                            // console.log(response.data)

                            this.registerFormData.password = ''
                            this.registerFormData.password_confirmation = ''
    
                            this.isLoading = false

             
                            
                        }).catch((err) => {
    
                            this.isLoading = false
                            console.log(err)
                            
                        });
    
                })
                .catch(error => {
    
                    console.log(error)
    
                })

            }

            


        },

        registerManager(){

            this.errorMessage = ''
            this.isLoading = true

            if(this.registerFormData.password != this.registerFormData.password_confirmation){

                this.errorMessage = "Passwords doesn't match"

                this.isLoading = false

                console.log("Passwords don't match")

            }else{



                apiClient.get('/sanctum/csrf-cookie').then(() => {

                    AuthService.registerThisManager(this.registerFormData)
                        .then((response) => { 
        
                            // this.router.push({ name: 'LoginView' })
                            this.router.push({ name: 'VerifyAuthCode' })
    
                            // console.log(response.data)

                            this.registerFormData.password = ''
                            this.registerFormData.password_confirmation = ''
    
                            this.isLoading = false

             
                            
                        }).catch((err) => {
    
                            this.isLoading = false
                            console.log(err)
                            
                        });
    
                })
                .catch(error => {
    
                    console.log(error)
    
                })

            }

            


        },

        async login(){

            this.isLoading = true
            this.errorMessage = ''

            apiClient.get('/sanctum/csrf-cookie').then(() => {

                AuthService.loginUser(this.loginFormData)
                    .then((response) => {


                        this.isLoading = false

                        // console.log(response.data)

                        // if (response.data.message === 1){

                        //     this.errorMessage = "The provided credentials are incorrect" 

                        // }else{

              
                    
                            //set token
                            this.token = response.data.token

                            //important: add upate the header with token
                            apiClient.interceptors.request.use((config) => {
                                config.headers.Authorization = `Bearer ${this.token}`
                                return config;
                            })

                            this.router.push({ name: 'MyDashboard' })

                            // console.log(response.data)

                        // }

                        
                    }).catch((err) => {

                        this.isLoading = false  

                        // this.errorMessage = err.response.data.error
                        this.errorMessage = "Unauthorised. Please make sure your email and password are correct."

                        console.log(err)
                        
                    });

            })
            .catch(error => {

                console.log(error)

            }) 


        },




        async logoutUser(){

            AuthService.logout() 
                .then((response) => {

                    //remove token from localstorage
                    this.token = ''

                    //clear login data from
                    this.loginFormData.email = ''
                    this.loginFormData.password = ''

                    window.localStorage.clear()
                    
                    this.router.push({name: 'LoginView'})

                    // console.log(response.data)
                    
                }).catch((err) => {

                    console.log(err)
                    
                });

        },

        verifyUserAuthCode(){

            this.errorMessage = ''

            const formData = {
                email: this.registerFormData.email,
                auth_code: this.authCode 
            }

            AuthService.verfiyAuthCode(formData)
                .then((response) => {

                    if (response.data.message === 'r3im7iwrf'){

                        this.router.push({ name: 'LoginView' })

                    } else if(response.data.message === 'auth_code_no_match'){

                        this.errorMessage = "The 6 digit code you entered doesn't match what was sent in the email. Please check again."

                        // console.log("The 6 digit code you entered doesn't match what was sent in the email. Please check again.")

                    } else{

                        this.errorMessage = "Oops, something went wrong. Please contact support."

                        // console.log("Something went wrong.")

                    }

                    
                }).catch((err) => {

                    console.log(err)
                    
                });

            console.log(formData)
        }, 


        forgotPassword(){ 

            this.errorMessage = ''
            this.successMessage = ''

            const formData = {
                email: this.email
            }

            this.isLoading = true


            AuthService.userForgotPassword(formData)
                .then((response) => {

                    if(response.data.message === 'success'){

                        this.successMessage = 'We have emailed your password reset link'

                        this.isLoading = false

                    }

                    if(response.data.message === 'user_email_not_found'){

                        this.successMessage = "We can't find a user with that email address"

                        this.isLoading = false

                    }

                    console.log(response.data)
                    
                }).catch((err) => {

                    this.isLoading = false

                    console.log(err)

                    
                    
                });

         


        },

        resetPassword(){

            this.errorMessage = ''

            // Check password length
            if (this.resetPasswordData.password.length < 8) {

                this.errorMessage = 'Password must be at least 8 characters';
       
                return;
            }


            //check if passwords match
            if(this.resetPasswordData.password === this.resetPasswordData.password_confirmation){


                const formData = {
                    email: this.resetPasswordData.email,
                    password: this.resetPasswordData.password,
                    password_confirmation: this.resetPasswordData.password_confirmation,
                    token: this.resetPasswordData.token
                }


                AuthService.userResetPassword(formData)
                    .then((response) => {

                        if(response.data.message === 'reset_success'){


                            this.router.push({ name: 'LoginView' })

                            // console.log(response.data)




                        }

                        
                        
                    }).catch((err) => {

                        this.errorMessage = err.response.data.message + ' Make sure you typed your email correctly.'

                        // console.log(err)
                        
                    });
                

            }else{

                this.errorMessage = 'Passwords do not match'

                console.log('not matched')

            }

            


        },


        getUserData(){

            AuthService.fetchUserData()
                .then((response) => {

                    this.userData = response.data.user 
                    this.currentPlan = response.data.plan
                    this.userCanceledAndIsOnGracePeriod = response.data.userCanceledAndIsOnGracePeriod
                    this.endsAt = response.data.endsAt
                    // console.log(response)
                    
                }).catch((err) => {

                    console.log(err) 
                    
                });

        },


        activateUserPaidPlanAfterPaddleSuccessCallback(paddle_plan_id){

            AuthService.activatePaidPlanNow(paddle_plan_id)
                .then((response) => {

                    // console.log(response.data)
                    
                }).catch((err) => {

                    console.log(err) 
                    
                });
            

        },

        getPlans(){ 

            AuthService.fetchBillingPlans()
                .then((response) => {

                    this.paddlePlanProducts = response.data.plans
                    
                }).catch((err) => {

                    console.log(err) 
                    
                });

        },


        swapCurrentPlan(newPlanUuid) {

            if (confirm('Are you sure you want to change to this plan?')) {

                AuthService.swapPlan(newPlanUuid)
                    .then((response) => {
                        this.getUserData() // Refresh
                        alert('Plan successfully changed!')
                        // console.log(response.data)
                    }).catch((err) => {
                        console.log(err)
                    });
            }
        },
        

    

        

        cancelPlan(){

            if (confirm('IMPORTANT: Are you sure you want to cancel your plan? All activity and on your account will stop and data deleted at the end of your subscription period.')) {

                AuthService.cancelThisPlan()
                .then((response) => {

                    this.getUserData() // Refresh
                    alert('Plan cancelled!')

                    // console.log(response.data)

                    
                }).catch((err) => {

                    console.log(err)
                    
                });
            }

            

        },


        projectLimitCheck(quizzes){

            // console.log(quizzes)

        },

        fetchManagerAccountUsageData(){

            AuthService.getAccountUsageData()
                .then((response) => {

                    this.accountUsageData = response.data.accountUsageData
                    
                    // console.log(response.data)
                    
                }).catch((err) => {

                    console.log(err)
                    
                });

        },

        checkAccountSubmissionLimit(){ 

            // //check usage against paln limit
            // if(this.accountUsageData.plan.monthly_submissions_limit === this.accountUsageData.usageData.current_submission_count){


            // }
            

        }







    }

})

